import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { SectionHeading } from '../components/SectionHeading';
import { AffiliationCard } from '../components/AffiliationCard';
import { affiliatedClubs } from '../data/affiliatedClubs';
export function AffiliatedClubs() {
  return <div className="w-full bg-club-canvas pb-24" data-id="element-572">
      <PageBanner title="Affiliated Clubs" eyebrow="Global Network" image="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80" data-id="element-573" />

      <div className="max-w-7xl mx-auto px-4 mt-20" data-id="element-574">
        <SectionHeading title="Our Global Network" eyebrow="Reciprocal Privileges" intro="As a member of Andhra Social & Cultural Association, you enjoy reciprocal privileges at some of the most prestigious private clubs around the world. Whether traveling for business or leisure, our network ensures you receive a warm welcome wherever you go." data-id="element-575" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16" data-id="element-576">
          {affiliatedClubs.map(club => <AffiliationCard key={club.id} id={club.id} name={club.name} location={club.location} image={club.image} desc={club.desc} data-id="element-577" />)}
        </div>
      </div>
    </div>;
}